import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/browser.svg';
const Browser = () => React.createElement(IconSvg, null);
export default Browser;
